export default __webpack_public_path__ + "static/media/1314 knife block A top.f7595d45.png";